namespace SP.Data {
    export class Order {

        static async getOrderInfo(orderId: number) {
            var response = await SP.get<any>("/api/v1/info/orderInfo/" + orderId);
            if (response.status == 200) return response.data as SP.OrderInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async searchOrderInfos(keyword: string) {
            const response = await fetch(`/api/v1/info/searchOrderInfos?keyword=${keyword}`, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                }
            });

            const result = await response.json();
            if (result.status = !200) await SP.alertX(result.msg);

            return result.data as OrderInfo[];
        }

        static async searchOrderInfosBasic(keyword: string) {
            const response = await fetch(`/api/v1/info/searchOrderInfosBasic?keyword=${keyword}`, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                }
            });

            const result = await response.json();
            if (result.status = !200) await SP.alertX(result.msg);

            return result.data as OrderInfo[];
        }
    }
}